


























import Vue from 'vue';
import { propOfType } from '@/services/utils';

import IconCheck20 from '@/components/icons/IconCheck20.vue';

export default Vue.extend({
  components: { IconCheck20 },
  props: {
    id: propOfType<string>(null),
    value: propOfType<boolean>(false),
    inputClass: propOfType<string | null>(null),
  },
  data() {
    return {
      model: this.value,
      focused: false,
    };
  },
  watch: {
    model() {
      this.$emit('input', this.model);
    },
    value() {
      this.model = this.value;
    },
  },
  methods: {
    onFocus() {
      this.focused = true;
      this.$emit('focus');
    },
    onBlur() {
      this.focused = false;
      this.$emit('blur');
    },
  },
});
